import { Dispatch, SetStateAction } from 'react';
import { Desktop, Mobile } from '../../../App';
import {
  BACKOFFICE_NAME,
  USDT,
  globalPlans
} from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, P1 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';

import { Checkbox } from '../Checkbox/Checkbox';

import { useTranslation } from 'react-i18next';
import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';

interface VirtualOfficePlanProps {
  selected: any;
  setSelected: Dispatch<SetStateAction<any>>;
}

export const VirtualOfficePlan = ({
  selected,
  setSelected
}: VirtualOfficePlanProps) => {
  const { t } = useTranslation('settings');

  return (
    <div>
      <P1 bold mb='20' mt='10' caps>
        Add {BACKOFFICE_NAME} SUBSCRIPTION:
      </P1>
      {globalPlans().map((plan, i) => (
        <VirtualOfficeSubscriptionStyled
          key={i}
          onClick={() => setSelected(plan)}>
          <div>
            <Flexed between>
              <Flexed center>
                <Checkbox
                  margin='0 20px 0 0'
                  size='38'
                  onClick={() => setSelected(plan)}
                  checked={selected?.id === plan.id}
                />
                <div>
                  <H3>{plan.title}</H3>
                </div>
              </Flexed>
              <Flexed alignEnd column>
                <Desktop>
                  <H2>
                    ${plan.price} {USDT}
                  </H2>
                </Desktop>
                <Mobile>
                  <H3>
                    ${plan.price} {USDT}
                  </H3>
                </Mobile>

                {plan.save && (
                  <CaptionText bold color={color.colors.secondary100}>
                    {t('virtual_office.plans.save')} {plan.save}%
                  </CaptionText>
                )}
              </Flexed>
            </Flexed>
          </div>
        </VirtualOfficeSubscriptionStyled>
      ))}
    </div>
  );
};
